import { observable } from 'mobx'
import Api from '@api/live'
import { getPosterByKey, gotoPoster, HLJ_STATISTIC } from '@util'
import posterApi from '@api/poster'

const BUSINESS_SCHOOL = `#/localMerchant/businessSchool`

export default class {
  @observable guide_list = []
  @observable poster

  init = () => {
    this.getList()
    this.getPoster()
  }

  preList = [
    {
      title: '直播白皮书',
      _href: 'https://www.yuque.com/zhiboxiaozhushou/tihy4t',
      list_img: 'https://qnm.hunliji.com/o_1dn75urqngbhlvj1or21uurtfpe.jpg'
    },
    {
      title: '直播协议',
      _href: 'https://www.yuque.com/zhiboxiaozhushou/tihy4t/kdai45#aGUUw',
      list_img: 'https://qnm.hunliji.com/o_1dn75v8e0rpk1rperm51a1t1hkcj.jpg'
    }
  ]

  getList = async () => {
    const { success } = await Api.liveChannelBusinessCollege()
    if (success) {
      // this.guide_list = data;
      this.guide_list = this.preList
    }
  }

  getPoster = async () => {
    const { success, data } = await posterApi.poster(2042)

    if (success) {
      this.poster = getPosterByKey(data, 'WEB_LIVE_GOOD_CASE')
    }
  }

  goArtical = (id, href) => () => {
    if (href) {
      window.open(href)
      HLJ_STATISTIC({
        page_name: '视频直播/直播帮助',
        event_type: 'element_hit',
        element_tag: 'live_lark_list',
        data_id: id,
        data_type: 'Lark'
      })
    } else {
      window.open(`${BUSINESS_SCHOOL}/${id}`)
      HLJ_STATISTIC({
        page_name: '视频直播/直播帮助',
        event_type: 'element_hit',
        element_tag: 'live_college_list',
        data_id: id,
        data_type: 'College'
      })
    }
  }

  goPoster = () => {
    gotoPoster(this.poster)
  }
}
